import React from 'react';
import PropTypes from 'prop-types';
import css from './MenuOption.css';
import Icon from '../SF/MaterialIcon';
import Caret from '../common/Caret';
import MenuOptionsList from './MenuOptionsList';
import { pathToLink, getColor } from '../utils/menuOptions';
import { camelCase } from 'lodash';

export default class MenuOption extends React.Component {

  constructor() {
    super();
    this.state = { showSuboptions: false };
  }

  onCaretClick() {
    this.setState({showSuboptions: !this.state.showSuboptions});
  }

  onOptionClick(e) {
    if ( this.props.onPathlessOptionClicked ) {
      e.preventDefault();
      this.props.onPathlessOptionClicked();
      this.props.updateSection();
    }
  }

  get icon() {
    return typeof this.props.icon === 'undefined' ? null : <Icon icon={this.props.icon} aria-hidden={true} />;
  }

  get caret() {
    if ( typeof this.props.suboptions === "undefined" || this.props.suboptions.length === 0 ) return null;
    return (
      <div id={camelCase("navSubMenu " + this.props.label)}>
        <Caret down={!this.state.showSuboptions} onClick={this.onCaretClick.bind(this)}/>
      </div>
    );
  }

  get suboptions() {
    return this.state.showSuboptions
      ? <MenuOptionsList options={this.props.suboptions} updateSection={this.props.updateSection} />
      : null;
  }

  get isActive() {
    return this.props.id && this.props.id === this.props.currentSection;
  }

  render() {
    return (
      <li className={css['container']} aria-expanded={this.state.showSuboptions} id={camelCase("nav " + this.props.label)}>
        <div style={{backgroundColor: getColor(this.props.path, window.location.pathname, this.isActive, this.props.currentSection)}}>
          <a
            href={pathToLink(this.props.path)}
            onClick={this.onOptionClick.bind(this)}>
            <span>{this.icon}</span>
            <span>{this.props.label}</span>
          </a>
          {this.caret}
        </div>
        {this.suboptions}
      </li>
    );
  }
}

MenuOption.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  suboptions: PropTypes.array,
  onPathlessOptionClicked: PropTypes.func,
  updateSection: PropTypes.func.isRequired,
  currentSection: PropTypes.string
};
